import { FormControl, FormLabel, Box, Input, Text } from "@chakra-ui/react";
import { ageOptions } from "../../data";
import { StudentForm } from "../../types";
import Select from "./Select";
import SubjectAccordion from "./SubjectAccordion";

const StudentDetailsForm = ({
  formValues,
  updateField,
  classes,
  subjects,
  formError,
}: {
  formValues: StudentForm;
  updateField: (key: string, value: string | string[]) => void;
  classes: string[];
  subjects: string[];
  formError: string;
}) => {
  return (
    <>
      <FormControl mb="2rem">
        <FormLabel htmlFor="name">Name of student</FormLabel>
        <Input
          placeholder="Enter student's name"
          name="name"
          value={formValues.name}
          onChange={(e) => updateField("name", e.target.value)}
          required
        />
      </FormControl>
      <Box
        mb="2rem"
        display={"grid"}
        gridTemplateColumns="25% 40% auto"
        gridColumnGap={"1rem"}
      >
        <Select
          options={ageOptions()}
          handleChange={(e) => updateField("age", e.target.value)}
          value={formValues.age}
          label={"Age"}
        />
        <Select
          options={classes}
          handleChange={(e) => updateField("class", e.target.value)}
          value={formValues.class}
          label={"Class"}
          loading={classes.length <= 0}
        />
        <Select
          options={["Male", "Female"]}
          handleChange={(e) => updateField("gender", e.target.value)}
          value={formValues.gender}
          label={"Gender"}
        />
      </Box>
      <FormControl>
        <FormLabel htmlFor="subjects">Subject(s) to be taught</FormLabel>
        <SubjectAccordion
          subjects={subjects}
          updateField={updateField}
          defaultChecked={true}
        />
      </FormControl>
      {formError && (
        <Text color="tomato" my="0.5rem" fontSize={"sm"}>
          {formError}
        </Text>
      )}
    </>
  );
};

export default StudentDetailsForm;
